import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import DrawingArea from './DrawingArea';
import ABCyaPhaser from '@abcya/abcya_phaser';

/**
 * 
 * @param {string} event - 'print or save'
 * @param {DrawingArea} drawingArea 
 */
export async function printSave(event, drawingArea) {
  drawingArea.getPrintable().snapshot(async (s) => {
    try {
      event === 'save' ? await ABCyaLib.PrintSave.instance.saveImage(s, { fileName: ABCyaPhaser.Localization.instance.getLocalizedString('save_file_name') }) : await ABCyaLib.PrintSave.instance.printImage(s);
    }
    catch (ex) {
      console.warn(ex);
    }
  });
};
